import { FlexRow, IconContainer, Text } from '@epam/promo';
import css from './BroadcastProgress.module.scss';
import { Icon } from '@epam/uui-core';

interface KeyValueRowProps {
  title: string;
  value: string | number;
  Icon: Icon;
  valueFontSize?: '12' | '14' | '18';
  iconColor?: string;
}

const KeyValueRow = ({
  title,
  value,
  Icon,
  iconColor = 'var(--uui-info-50)',
  valueFontSize = '18',
}: KeyValueRowProps) => {
  return (
    <FlexRow cx={css.progress__row}>
      <IconContainer icon={Icon} size="18" style={{ fill: iconColor }} />
      <Text color="gray60" fontSize="14">{`${title}:`}</Text>
      <Text fontSize={valueFontSize} fontWeight="600">
        {value}
      </Text>
    </FlexRow>
  );
};

export default KeyValueRow;
